import { useEffect, useRef } from "react";
import { Copy, Edit3, Eye, MoreVertical, Star, Trash2 } from "lucide-react";

function SpecialActionsMenu({
  special,
  isOpen,
  onClose,
  onToggle,
  onEdit,
  onPreview,
  onToggleFeatured,
  onDuplicate,
  onDelete,
}) {
  const menuRef = useRef(null);

  useEffect(() => {
    if (!isOpen) {
      return undefined;
    }

    function handlePointerDown(event) {
      if (!menuRef.current?.contains(event.target)) {
        onClose();
      }
    }

    function handleKeyDown(event) {
      if (event.key === "Escape") {
        onClose();
      }
    }

    document.addEventListener("mousedown", handlePointerDown);
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("mousedown", handlePointerDown);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOpen, onClose]);

  function runAction(action) {
    if (!action) {
      return;
    }

    onClose();
    action(special);
  }

  const actions = [
    {
      label: "Edit",
      icon: Edit3,
      onClick: onEdit,
    },
    {
      label: "Preview",
      icon: Eye,
      onClick: onPreview,
    },
    {
      label: special.is_featured ? "Remove featured" : "Feature",
      icon: Star,
      onClick: onToggleFeatured,
    },
    {
      label: "Duplicate",
      icon: Copy,
      onClick: onDuplicate,
    },
    {
      label: "Delete",
      icon: Trash2,
      onClick: onDelete,
      danger: true,
    },
  ].filter((action) => action.icon && action.onClick);

  return (
    <div className="special-actions-menu" ref={menuRef}>
      <button
        type="button"
        className="special-actions-menu__trigger"
        title={`More actions for ${special.name}`}
        aria-label={`More actions for ${special.name}`}
        aria-haspopup="menu"
        aria-expanded={isOpen}
        onClick={onToggle}
      >
        <MoreVertical size={18} />
      </button>

      {isOpen && (
        <div
          className="special-actions-menu__dropdown"
          role="menu"
          aria-label={`Actions for ${special.name}`}
        >
          {actions.map((action) => {
            const Icon = action.icon;

            return (
              <button
                key={action.label}
                type="button"
                role="menuitem"
                className={
                  action.danger
                    ? "special-actions-menu__danger"
                    : undefined
                }
                onClick={() => runAction(action.onClick)}
              >
                <Icon size={15} />
                {action.label}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default SpecialActionsMenu;